<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp" id="pt1"> </p>
<p class="PT"><span epub:type="pagebreak" id="pg_1" title="1"><span href="#/xhtml/contents#c_pt1" title="Link target outside of Sample"><span class="ePub-I">How Do I Live a Full Life?</span></span></span></p>
<p class="PEP1">Pay attention.</p>
<p class="PEP1">Be astonished.</p>
<p class="PEP">Tell about it.</p>
<p class="PEPC"><span class="mdash">—</span>M<span class="ePub-SC">ARY</span> O<span class="ePub-SC">LIVER</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?704fbaa8